/** @file loadGltfMesh: GLB bytes imported into a scene through Babylon's glTF loader. */
import '@babylonjs/loaders/glTF/glTFFileLoader.js';
import '@babylonjs/loaders/glTF/2.0/index.js';
import { ImportMeshAsync } from '@babylonjs/core/Loading/sceneLoader.js';
import type { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh.js';
import type { Scene } from '@babylonjs/core/scene.js';

/** Every mesh of the GLB (`[0]` is the loader's `__root__`), imported from bytes; `name` names the load in errors. */
export async function loadGltfMesh(scene: Scene, bytes: Uint8Array, name: string): Promise<AbstractMesh[]> {
  const result = await ImportMeshAsync(bytes, scene, { pluginExtension: '.glb', name });
  return result.meshes;
}
